import { AssetFilterScreen, AssetFilterScreenHandle, SlideAction, SlideLayout, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import { AssetComponent } from './assetComponent';
import { AssetsFilters } from './assetsFilters';

export const AssetsFilterPage = () => {
  const filterRef = useRef<AssetFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetComponent />,
    headerComponent: <AssetsFilters />,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'assets.menu.title',
    mainComponent: (
      <>
        <AssetFilterScreen
          ref={filterRef}
          mode="page"
          isVisible={true}
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton
        onReset={() => filterRef.current?.onReset()}
      />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/assets');
  };

  return null;
};

